import ProductSubTypes from "../../components/ProductSubTypes";

export default function ProductSubTypesScreen(){
return <ProductSubTypes />
}